import React from 'react'
import './tableNormas.css'

const TableNormas = ({ columns = [], data }) => {
    return (
        <section style={{ width: '100%', marginTop: '40px', marginBottom: '40px' }}>
            <table>
                <thead>
                    <tr>
                        {columns.map((column, index) => (
                            <th key={index}>{column.title}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data.map((row, index) => (
                        <tr key={index}>
                            {row.codigo && (
                                <td style={{ textAlign: row?.align }} className={row?.className}>
                                    {row?.codigo}
                                </td>
                            )}
                            {row.norma && (
                                <td style={{ textAlign: row?.align }} className={row?.className}>
                                    {row?.norma}
                                </td>
                            )}
                            {row.nombre && (
                                <td style={{ textAlign: row?.align }} className={row?.className}>
                                    <a href={row?.enlace} target="_blank" style={{ textDecoration: "underline" }}>
                                        {row?.nombre}
                                    </a>
                                </td>
                            )}
                            {row.publicacion && (
                                <td style={{ textAlign: row?.align }} className={row?.className}>
                                    {row?.publicacion}
                                </td>
                            )}
                            {row.vigencia && (
                                <td style={{ textAlign: row?.align }} className={row?.className}>
                                    {row?.vigencia?.split('\n').map((line, index) => (
                                        <span key={index}>
                                            {line}
                                            <br />
                                        </span>
                                    ))}
                                </td>
                            )}
                        </tr>
                    ))}
                </tbody>
            </table>
        </section>
    )
}

export default TableNormas
